import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import SetTitle from "../../utils/set_title";
import {BASE_URL} from "../../utils";
import Header from '../../components/Headers/Header'


export default function PEDFile() {
	SetTitle('PED Generation')
	const params = useParams()

	useEffect(() => {
    	downloadData()
  	}, [])

	const downloadData = () => {
		if (params?.id) {
			setTimeout(() => {
				window.location.href = BASE_URL+'/api/1/get-ped-generator/'+params.id
				setTimeout(() => {
					window.location.href = '/ped-generator'
				}, 5000)
			}, 1000)
		}
		else {
			setTimeout(() => {
				window.location.href = '/ped-generator'
			}, 1000)
		}
	}

	return (
		<Header
			iconClass="ni ni-folder-17 text-white"
			title="PED Generator"
			description="Download in corso..."
		/>
	)
}
